import React, { useState } from 'react'
import { Outlet, useParams, NavLink } from 'react-router-dom'
import Shell from '../components/Shell'
import { CaseListSidebar } from '../components/app/CaseListSidebar'
import FloatingCaseIntelligence from '../components/app/incomeVerification/floating/FloatingCaseIntelligence'
import styles from './CasePage.module.css'

const CasePage: React.FC = () => {
  const { caseId } = useParams<{ caseId: string }>()
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false)

  const handleToggleSidebar = () => {
    setSidebarCollapsed(!sidebarCollapsed)
  }

  return (
    <Shell variant="app" showFooter={false}>
      <div className={styles.pageLayout}>
        {/* Case List Sidebar */}
        <CaseListSidebar
          collapsed={sidebarCollapsed}
          onToggleCollapse={handleToggleSidebar}
        />

        {/* Main Area */}
        <div className={styles.mainArea}>
          {/* Case Header */}
          <header className={styles.header}>

            {/* Workflow Navigation Tabs */}
            <nav className={styles.workflowNav}>
              <NavLink
                to={`/quick-check/${caseId}/documents`}
                className={({ isActive }) =>
                  `${styles.navTab} ${isActive ? styles.navTabActive : ''}`
                }
              >
                Documents
              </NavLink>
              <NavLink
                to={`/quick-check/${caseId}/income`}
                className={({ isActive }) =>
                  `${styles.navTab} ${isActive ? styles.navTabActive : ''}`
                }
              >
                Income Verification
              </NavLink>
              <NavLink
                to={`/quick-check/${caseId}/cashflow`}
                className={({ isActive }) =>
                  `${styles.navTab} ${styles.navTabDisabled} ${isActive ? styles.navTabActive : ''}`
                }
              >
                Cash Flow
              </NavLink>
              <NavLink
                to={`/quick-check/${caseId}/assets`}
                className={({ isActive }) =>
                  `${styles.navTab} ${styles.navTabDisabled} ${isActive ? styles.navTabActive : ''}`
                }
              >
                Assets
              </NavLink>
              <NavLink
                to={`/quick-check/${caseId}/debt`}
                className={({ isActive }) =>
                  `${styles.navTab} ${styles.navTabDisabled} ${isActive ? styles.navTabActive : ''}`
                }
              >
                Debt
              </NavLink>
            </nav>
          </header>

          {/* Main Content - Outlet renders the matched child route */}
          <main className={styles.content}>
            <Outlet />
          </main>
        </div>

        {/* Floating AI Intelligence Panel */}
        <FloatingCaseIntelligence caseId={caseId || null} />
      </div>
    </Shell>
  )
}

export default CasePage
